import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BaseHttpService, Query, UriBuilderParams } from "./base/base-http.service";
import { PaymentType } from "@app/shared/models/payment-type";
import { BackendUriUnits } from "./base/backend-uri-units";
import { DrQueryParams } from "./base/base-service-with-bundle.service";
import { BaseList, BaseWithIdList } from "@app/shared/models/list";
import { HttpServiceBundle } from "./base/http-service-bundle.service";

export class PaymentTypeBuilderUriParams extends UriBuilderParams<PaymentType> {
    
    constructor(paymentType?: PaymentType | string) {
        super(paymentType);
    }

    public buildUri(): string {
        const uri = `/${BackendUriUnits.PAYMENT_TYPES}`;
        return uri;
    }
}

@Injectable({
    providedIn: 'root'
})
export class PaymentTypeService extends BaseHttpService<PaymentType, PaymentTypeBuilderUriParams>
                                implements Query<PaymentType, PaymentTypeBuilderUriParams> {

    constructor(httpServiceBundle: HttpServiceBundle) {
        super(PaymentType, httpServiceBundle);
    }

    public query(uriParams: PaymentTypeBuilderUriParams, params?: DrQueryParams, propOverride?: string): Observable<BaseList<PaymentType>> {
        return this.queryBase(uriParams, params);   
    }

}